/**
 * FeedProfileCard.js — EcoScienceInnova
 * Sidebar left widget: user profile card with stats.
 *
 * Props:
 *  - user:          Auth user object OR { name, email, profile }
 *  - statsLeft:     { label, value }  — e.g. { label: 'Publicaciones', value: 128 }
 *  - statsRight:    { label, value }  — e.g. { label: 'Conexiones', value: 512 }
 *  - onEditProfile: () => void
 *  - editLabel:     string — button text
 */
import React from 'react';
import FeedAvatar from './FeedAvatar';
import './feed.shared.css';

const FeedProfileCard = ({
    user,
    statsLeft,
    statsRight,
    onEditProfile,
    editLabel = 'Editar Perfil',
}) => {
    const displayName = user?.profile
        ? `${user.profile.firstName} ${user.profile.lastName}`
        : (user?.name || user?.email || 'Usuario');

    const displayRole = user?.email || user?.role || '';
    const photoUrl = user?.profile?.photoUrl || null;

    return (
        <div className="feed-profile-card">
            <div className="feed-profile-banner" />
            <FeedAvatar
                name={displayName}
                size={72}
                src={photoUrl}
                className="feed-profile-avatar"
                onClick={onEditProfile}
            />
            <h3 className="feed-profile-name">{displayName}</h3>
            {displayRole && <p className="feed-profile-role">{displayRole}</p>}

            {onEditProfile && (
                <button className="feed-edit-profile-btn" onClick={onEditProfile}>
                    {editLabel}
                </button>
            )}

            {(statsLeft || statsRight) && (
                <div className="feed-profile-stats">
                    {statsLeft && (
                        <div>
                            <strong>{statsLeft.value?.toLocaleString?.() ?? statsLeft.value}</strong>
                            <span>{statsLeft.label}</span>
                        </div>
                    )}
                    {statsLeft && statsRight && <div className="feed-stat-divider" />}
                    {statsRight && (
                        <div>
                            <strong>{statsRight.value?.toLocaleString?.() ?? statsRight.value}</strong>
                            <span>{statsRight.label}</span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default FeedProfileCard;
